import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../components/Request/Request";
//import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../utils/Utils";
import * as AppActions from '../../actions/AppActions';
const AsgariUcretTanimDetay = (props) => {

    const dispatch = useDispatch();

    const [data, setData] = useState();
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        getData();

        setTimeout(function () { //Start the timer
            setIsEdit(true);
        }.bind(this), 1000)
    }, [])

    const getData = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        } else if (props.data) {
            setData(props.data);
            return;
        } else {
            setData({});
            return;
        }
        dispatch(AppActions.setLoading(true, "Kayıt Yükleniyor.."));
        const request = new Request("/emeklilik-app/api/asgari-ucret-tanim/getKayit/" + id, "GET");
        return request.run()
            .then(response => {
                setData(response.data.data);
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let formData = data;

        let method = "POST"
        let url = "/emeklilik-app/api/asgari-ucret-tanim/save";


        const request = new Request(url, method, formData);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }

    const onTutarValueChanged = (e) => {

        if (!isEdit) {
            return;
        }

        let tutar = 0;
        let maxOran = 0;
        let maxTutari = 0;
        let gunlukTutari = 0;
        if (data.asgariUcretTutari && data.asgariUcretTutari > 0) {
            tutar = data.asgariUcretTutari
            gunlukTutari = (tutar / 30);
            gunlukTutari = gunlukTutari.toFixed(2);
        }

        if (data.asgariUcretMaxTutari && data.asgariUcretMaxTutari > 0) {
            maxTutari = data.asgariUcretMaxTutari
        }

        if (data.asgariUcretMaxOran && data.asgariUcretMaxOran > 0) {
            maxOran = data.asgariUcretMaxOran
        }
        //let maxOran = 7.5;
        maxTutari = tutar * maxOran;


        setData(Object.assign({}, data, {
            asgariUcretGunlukTutari: gunlukTutari,
            asgariUcretMaxTutari: maxTutari,
            asgariUcretMaxOran: maxOran
        }));

    }
    const onMaxTutarValueChanged = (e) => {

        if (!isEdit) {
            return;
        }

        let tutar = 0;
        let maxOran = 0;
        let maxTutari = 0;
        if (data.asgariUcretTutari && data.asgariUcretTutari > 0) {
            tutar = data.asgariUcretTutari
        } else {
            return;
        }

        if (data.asgariUcretMaxTutari && data.asgariUcretMaxTutari > 0) {
            maxTutari = data.asgariUcretMaxTutari
            maxOran = maxTutari / tutar;
            maxOran = maxOran.toFixed(2);
        }  

        setIsEdit(false);
        setData(Object.assign({}, data, {
            asgariUcretMaxOran: maxOran
        }));

        setTimeout(function () { //Start the timer
            setIsEdit(true);
        }.bind(this), 1000)

    }
    const onMaxOranValueChanged = (e) => {

        if (!isEdit) {
            return;
        }

        let tutar = 0;
        let maxOran = 0;
        let maxTutari = 0;
        if (data.asgariUcretTutari && data.asgariUcretTutari > 0) {
            tutar = data.asgariUcretTutari
        }
        if (data.asgariUcretMaxOran && data.asgariUcretMaxOran > 0) {
            maxOran = data.asgariUcretMaxOran
        }
 
        maxTutari = tutar * maxOran;
        maxTutari = maxTutari.toFixed(2);

        setData(Object.assign({}, data, {
            asgariUcretMaxTutari: maxTutari
        }));

    }
    return (
        <div >
            <Form formData={data} colCount={1} id="form" labelLocation={"left"} className="option" >

                <Item disabled={false} dataField={'baslangicTarihi'} editorType={'dxDateBox'}
                    editorOptions={{
                        displayFormat: "yyyy-MM-dd"
                    }}>
                    <RequiredRule message="Başlangıç Tarihi bilgisi gerekli" />
                    <Label text='Başlangıç Tarihi' />
                </Item>
                <Item disabled={false} dataField={'bitisTarihi'} editorType={'dxDateBox'}
                    editorOptions={{
                        displayFormat: "yyyy-MM-dd"
                    }}>
                    <Label text='Bitiş Tarihi' />
                </Item>

                <Item disabled={false} dataField={'asgariUcretTutari'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        format: "#,##0.00",
                        onValueChanged: onTutarValueChanged
                    }}>
                    <RequiredRule message="Tutar bilgisi gerekli" />
                    <Label text='Tutar' />
                </Item>

                <Item disabled={false} dataField={'asgariUcretGunlukTutari'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        format: "#,##0.00"
                    }}>
                    <RequiredRule message="Günlük Tutar bilgisi gerekli" />
                    <Label text='Günlük Tutar' />
                </Item>

                <Item disabled={false} dataField={'asgariUcretMaxTutari'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        format: "#,##0.00",
                        onValueChanged: onMaxTutarValueChanged
                    }}>
                    <RequiredRule message="Max Tutar bilgisi gerekli" />
                    <Label text='Max Tutar' />
                </Item>

                <Item disabled={false} dataField={'asgariUcretMaxOran'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        format: "#,##0.00",
                        onValueChanged: onMaxOranValueChanged
                    }}>
                    <RequiredRule message="Max Oran bilgisi gerekli" />
                    <Label text='Max Oran' />
                </Item>

                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default AsgariUcretTanimDetay;
